export default __webpack_public_path__ + "static/media/kan11-black.144dbc93.svg";